import {fromJS, Map, List} from 'immutable';
import * as actionTypes from 'requests/actionTypes';
import {POST, DELETE} from 'requests/methods';
import {PUBLISHED} from 'actions';

const LOCAL_STORAGE_KEY = 'kitMutations';

export const MUTATION_TYPE_CREATED = 'created';
export const MUTATION_TYPE_DELETED = 'deleted';
export const MUTATION_TYPE_UNKNOWN = 'unknown';

function kitTokenFromRequest(request) {
  const url = request.url;
  let kitToken = null;

  if (url[0] === 'api' && url[1] === 'kits' && url.length > 2) {
    kitToken = url[2];
  }

  return kitToken;
}

function typeFromRequest(request) {
  const url = request.url;
  let type = null;

  if (url.length > 3) {
    type = url[3];
  }

  return type;
}

function mutationTypeForRequest(request) {
  let mutationType = MUTATION_TYPE_UNKNOWN;

  if (request.method === POST) {
    mutationType = MUTATION_TYPE_CREATED;
  }

  if (request.method === DELETE) {
    mutationType = MUTATION_TYPE_DELETED;
  }

  return mutationType;
}

const fromLocalStorage = () => {
  const defaultValue = JSON.stringify(
    Map({
      changesSinceLastPublish: Map(),
    }).toJS()
  );
  let changesSinceLastPublish;

  try {
    changesSinceLastPublish = window.localStorage.getItem(LOCAL_STORAGE_KEY);
  } catch (e) { }

  return fromJS(JSON.parse(changesSinceLastPublish || defaultValue));
};

export function kitMutations(state = null, action) {
  let nextState = state || fromLocalStorage();

  const indicatesMutation = [actionTypes.RESPONSE_CREATED, actionTypes.RESPONSE_DELETED];

  if (action.type === PUBLISHED) {
    nextState = nextState.updateIn(['changesSinceLastPublish', action.kitToken], () => Map());
  }

  if (~indicatesMutation.indexOf(action.type)) {
    const kitToken = kitTokenFromRequest(action.request);
    const type = typeFromRequest(action.request);
    const mutationType = mutationTypeForRequest(action.request);

    if (kitToken && ~['working-set-icons', 'working-set-typefaces', 'working-set-images'].indexOf(type)) {
      nextState = nextState.updateIn(['changesSinceLastPublish', kitToken, type, mutationType], List(), (changesSinceLastPublish) => {
        return changesSinceLastPublish.push(action.request.toImmutable());
      });
    }
  }

  try {
    window.localStorage.setItem(LOCAL_STORAGE_KEY, JSON.stringify(nextState.toJS()));
  } catch (e) {}

  return nextState;
}



// WEBPACK FOOTER //
// ./app/javascript/reducers/publish.js